import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import ru from './locales/ru.json';

/** Все строки интерфейса — в ресурсах i18next `ru` (NFR-7); новый язык — без изменения кода. */
export const resources = { ru: { translation: ru } } as const;

declare module 'i18next' {
  interface CustomTypeOptions {
    resources: (typeof resources)['ru'];
  }
}

void i18next.use(initReactI18next).init({
  lng: 'ru',
  fallbackLng: 'ru',
  resources,
  interpolation: { escapeValue: false },
});

export default i18next;
